import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import { useDispatch, useSelector } from 'react-redux';

const GlobalPromoTilesTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  const dispatch = useDispatch();
  const { globalPromoTiles } = useSelector((state) => state['demo-common']);

  const promosData = {
    endDate: data.endDate,
    overrideEverything: data.overrideEverything,
    promoTile: data.promoTile,
    startDate: data.startDate,
    applyCondition: data.applyCondition,
    categories: data.categories,
  }

  if (!globalPromoTiles) {
    dispatch({ type: 'globalPromoTiles', data: promosData });
  }

  return null;
};

export default tastify({ translate: true, connect: { context: true } })(GlobalPromoTilesTastic);
